import gameIds from 'a/hub/data/GameIds';

export const GAME_ID = gameIds.SORT_IT_OUT;

export const MASTER_CRITERIA = 8;

export const NUM_QUESTIONS = 9;

export const HARD = 'hard';

export const CATEGORIES = {
  HARD_C: 'hard c',
  SOFT_C: 'soft c',
  HARD_G: 'hard g',
  SOFT_G: 'soft g',
  HARD_Y: 'hard y',
  SOFT_Y: 'soft y',
};

// Game screens
export const SCREENS = {
  PROGRESS: 'PROGRESS',
  PRACTICE: 'PRACTICE',
  INSTRUCTION: 'INSTRUCTION',
  ONBOARDING: 'ONBOARDING',
  ONBOARDING_REPEAT: 'ONBOARDING_REPEAT',
  STANDARD_VIEW: 'STANDARD_VIEW',
  LOADING: 'LOADING',
};

// Alex states
export const ALEX_STATES = {
  INACTIVE: 0,
  ACTIVE: 1,
  SPEAKING: 2,
};

export const REDUX_ACTIONS = {
  CHANGE_SCREEN: 'CHANGE_SCREEN',
  INIT_ROUND: 'INIT_ROUND',
  SET_HAS_SEEN_ONBOARDING: 'SET_HAS_SEEN_ONBOARDING',
  MOVE_TO_CATEGORY: 'MOVE_TO_CATEGORY',
  INCREMENT_QUESTIONS_ANSWERED: 'INCREMENT_QUESTIONS_ANSWERED',
  INCREMENT_ANSWERS_CORRECT: 'INCREMENT_ANSWERS_CORRECT',
  INCREMENT_ANSWERS_INCORRECT: 'INCREMENT_ANSWERS_INCORRECT',
  INCREMENT_ATTEMPTS_COUNTER: 'INCREMENT_ATTEMPTS_COUNTER',
  NEXT_QUEUE_ITEM: 'NEXT_QUEUE_ITEM',
  INIT_LAYOUT: 'INIT_LAYOUT',
  SET_DROP_ANIMATION_STARTED: 'SET_DROP_ANIMATION_STARTED',
  ADD_BITES_EARNED: 'ADD_BITES_EARNED',
  SET_LAST_LEVEL_MASTERED: 'SET_LAST_LEVEL_MASTERED',
  INCREMENT_LEVEL_PLAYED_COUNTER: 'SET_LEVEL_PLAYED_COUNTER',
  SET_INTERACTION_LOCKED: 'SET_INTERACTION_LOCKED',
  SET_LEVEL_MASTERED: 'SET_LEVEL_MASTERED',
  NEXT_PRACTICE_ITEM: 'NEXT_PRACTICE_ITEM',
  SET_HIDDEN_CATEGORY: 'SET_HIDDEN_CATEGORY',
  SET_SELECTED_CATEGORY: 'SET_SELECTED_CATEGORY',
  ADD_PRACTICE_QUESTION: 'ADD_PRACTICE_QUESTION',
  START_PRACTICE: 'START_PRACTICE',
  SET_ALEX_INACTIVE: 'SET_ALEX_INACTIVE',
  SET_ALEX_ACTIVE: 'SET_ALEX_ACTIVE',
  SET_ALEX_SPEAKING: 'SET_ALEX_SPEAKING',
  SET_PRACTICE_INTERACTION_LOCKED: 'SET_PRACTICE_INTERACTION_LOCKED',
  INCREMENT_PRACTICE_QUESTIONS_ANSWERED: 'INCREMENT_PRACTICE_QUESTIONS_ANSWERED',
  SET_HIGHLIGHTED_CATEGORY: 'SET_HIGHLIGHTED_CATEGORY',
  SET_AUDIO_CATEGORY: 'SET_AUDIO_CATEGORY',
  SET_HIGHLIGHTED_INSTRUCTION_CATEGORY: 'SET_HIGHLIGHTED_INSTRUCTION_CATEGORY',
  SET_INSTRUCTION_CATEGORIES_VISIBLE: 'SET_INSTRUCTION_CATEGORIES_VISIBLE',
  SET_COLUMN_INDEX: 'SET_COLUMN_INDEX',
  SET_MAGNIFIED_CELL: 'SET_MAGNIFIED_CELL',
  SET_HIGHLIGHTED_CELL: 'SET_HIGHLIGHTED_CELL',
  SET_ROW_INDEX: 'SET_ROW_INDEX',
  INIT_INSTRUCTION: 'INIT_INSTRUCTION',
  SET_HIDDEN_CELLS: 'SET_HIDDEN_CELLS',
  CHANGE_INSTRUCTION_STAGE: 'CHANGE_INSTRUCTION_STAGE',
  ADD_CELLS: 'ADD_CELLS',
  UPDATE_CELL_POSITION: 'UPDATE_CELL_POSITION',
  MOVE_COLUMN: 'MOVE_COLUMN',
  REMOVE_CELLS: 'REMOVE_CELLS',
  SHIFT_ROW: 'SHIFT_ROW',
  INIT_ONBOARDING: 'INIT_ONBOARDING',
  SET_HIGHLIGHTED_ONBOARDING_CATEGORY: 'SET_HIGHLIGHTED_ONBOARDING_CATEGORY',
  NEXT_ONBOARDING_ITEM: 'NEXT_ONBOARDING_ITEM',
  SET_HIGHLIGHTED_ONBOARDING_ARROW: 'SET_HIGHLIGHTED_ONBOARDING_ARROW',
  MOVE_TO_ONBOARDIBNG_CATEGORY: 'MOVE_TO_ONBOARDIBNG_CATEGORY',
  SET_ONBOARDING_INTERACTION_LOCKED: 'SET_ONBOARDING_INTERACTION_LOCKED',
  SET_COLUMN_SHIFT_STEP: 'SET_COLUMN_SHIFT_STEP',
  SET_LEVEL_COUNT: 'SET_LEVEL_COUNT',
};

export const INSTRUCTION_STAGES = {
  INTRO: 'INTRO',
  INIT_GRID: 'INIT_GRID',
};
